<script setup lang="ts">
import { computed } from 'vue'
import { useGeoStore } from '@/stores/geo'

import { BASEMAPS } from './basemaps'

const props = defineProps<{
  modelValue: string
  orgId?: number | string
}>()
const emit = defineEmits<{ 'update:modelValue': [string] }>()

const geoStore = useGeoStore()
const planetAccess = computed(() => geoStore.getIsPlanetscopeAccess)

const options = computed(() =>
  BASEMAPS.filter(b => !b.requiresPlanetAccess || planetAccess.value)
)

const select = (key: string) => emit('update:modelValue', key)
</script>

<template>
  <div class="space-y-1">
    <label
      v-for="b in options"
      :key="b.key"
      class="flex items-center cursor-pointer space-x-2 rounded p-1 hover:bg-muted/60"
      @click="select(b.key)"
    >
      <img
        :src="b.preview"
        class="w-10 h-10 object-cover rounded border-2 border-gray-300"
        :class="{ 'border-primary': b.key === modelValue }"
      />
      <span class="text-sm" :class="{ 'text-primary font-medium': b.key === modelValue }">{{ b.label }}</span>
    </label>
  </div>
</template>
